import moment from 'moment';
import { Spreadsheet } from '../models/spreadsheet';
import environment from '../scripts/environment';

export class PointOfInterestSpreadsheet extends Spreadsheet {
    name: string = `pontos_de_interesse`;

    mount(dataSource: any[]) {
        const columns = [
            { text: 'Id', value: p => p.Id, width: 60 },
            { text: 'Nome', value: p => p.Name, width: 250 },
            { text: 'Descrição', value: p => p.Description, width: 250 },
            { text: 'Endereço', value: p => p.Logradouro, width: 250 },
            { text: 'Bairro', value: p => p.Neighborhood, width: 150 },
            { text: 'Cidade', value: p => p.County, width: 150 },
            { text: 'UF', value: p => p.FederativeUnit, width: 50 },
            { text: 'CEP', value: p => p.Cep, width: 90 },
            { text: 'Latitude', value: p => p.Latitude, width: 110 },
            { text: 'Longitude', value: p => p.Longitude, width: 110 },
            { text: 'Data de Cadastro', value: p => p.CreatedAt ? moment(p.CreatedAt).format('DD/MM/YYYY') : '', width: 110 },
            { text: 'Criado por', value: p => p.CreatedByName, width: 200 },
            { text: 'Email', value: p => p.CreatedByEmail, width: 220 }
        ];

        this.workbookOptions = {
            sheets: [{
                name: 'Pontos de Interesse',
                rows: [
                    {
                        cells: columns.map((column, index) => ({
                            index, value: column.text, background: '#000000', color: '#FFFFFF', bold: true, textAlign: 'center'
                        }))
                    },
                    ...dataSource.map(feature => ({
                        cells: columns.map((column, index) => ({
                            index, value: column.value(feature.properties)
                        }))
                    }))
                ],
                columns: columns.map(column => ({ width: column.width }))
            }]
        };

        return this;
    }

    saveAsExcel() {
        if (this.workbook) {
            kendo.saveAs({
                dataURI: this.workbook.toDataURL(),
                fileName: `${environment.get('CONFIG.CLIENT')}_Pontos de Interesse_v${moment().format('YYYYMMDD')}.xlsx`
            });
        }

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/point-of-interest-spreadsheet.js